export const enum SsciRoutes {
  baggage = 'services/baggage',
  boardingPass = 'boarding-pass',
  boardingPassDelivery = 'boarding-pass-delivery',
  customerContact = 'customer-contact',
  dangerousGoods = 'dangerous-goods',
  homePrintedBagTags = 'bag-tags',
  identification = 'identification',
  journeySelection = 'journey-selection',
  securityQuestions = 'security-questions',
  passengerSelection = 'passenger-selection',
  payment = 'payment',
  seatmap = 'services/seatmap',
  overview = 'overview',
  regulatoryDetails = 'regulatory-details',
  challenge = 'challenge',
  checkinError = 'checkin-error',
  catalog = 'catalog',
  service = 'service',
  cancel = 'cancellation',
  verification = 'verification',
  confirmCancelCheckin = 'confirmation',
  passengerSelectionContact = 'passenger-selection-contact',
  travelerIdentityWidgetPassport = 'travelerIdentity-widget-passport',
  travelerIdentityWidgetEntryVerifier = 'travelerIdentity-widget-entry-verifier',
  reviewCheckin = 'review-checkin',
  voluntaryDeniedBoarding = 'voluntary-denied-boarding',
  mandate = 'mandate',
  exitRowEligibility = 'exit-row-eligibility',
  alternativeFlights = 'alternative-flights'
}

export const enum AutoCheckinLandingRoute {
  landing = 'auto-checkin'
}

export const enum DirectBoardingPassRoute {
  landing = 'bp'
}

export const enum AutoCheckinRoutes {
  autoCheckinError = 'auto-checkin-error',
  autoCheckinDangerousGoods = 'auto-checkin-dangerous-goods',
  autoCheckinBoardingPass = 'auto-checkin-boarding-pass'
}

export const enum SsciRouteParams {
  journeyId = 'journeyId',
  travelerId = 'travelerId',
  flightId = 'flightId',
  serviceId = 'serviceId',
  serviceCode = 'serviceCode',
  travelerIdentityWidgetType = 'travelerIdentityWidgetType',
  legId = 'legId'
}

export const enum pageIds {
  baggage = 'BAGGAGE',
  boardingPass = 'BOARDINGPASS',
  boardingPassDelivery = 'BOARDINGPASSDELIVERY',
  challenge = 'CHALLENGE',
  checkinError = 'CHECKINERROR',
  autoCheckinError = 'AUTOCHECKINERROR',
  autoCheckinDangerousGoods = 'AUTOCHECKINDANGEROUSGOODS',
  autoCheckinBoardingPass = 'AUTOCHECKINBOARDINGPASS',
  customerContact = 'CUSTOMERCONTACT',
  dangerousGoods = 'DANGEROUSGOODS',
  identification = 'IDENTIFICATION',
  journeySelection = 'JOURNEYSELECTION',
  passengerSelection = 'PASSENGERSELECTION',
  passengerSelectionContact = 'PASSENGERSELECTIONCONTACT',
  overview = 'OVERVIEW',
  homePrintedBagTags = 'HOMEPRINTEDBAGTAGS',
  payment = 'PAYMENT',
  regulatoryDetails = 'REGULATORYDETAILS',
  seatmap = 'SEATMAP',
  securityQuestions = 'SECURITYQUESTIONS',
  catalog = 'CATALOG',
  service = 'SERVICE',
  cancel = 'CANCEL',
  verification = 'VERIFICATION',
  confirmation = 'CONFIRMATION',
  travelerIdentityWidgetPassport = 'TRAVELERIDENTITYWIDGETPASSPORT',
  travelerIdentityWidgetEntryVerifier = 'TRAVELERIDENTITYWIDGETENTRYVERIFIER',
  reviewCheckin = 'REVIEWCHECKIN',
  mandate = 'MANDATE',
  exitRowEligibility = 'EXITROWELIGIBILITY',
  voluntaryDeniedBoarding = 'VOLUNTARYDENIEDBOARDING',
  alternativeFlights = 'ALTERNATIVEFLIGHTS'
}

export const pageNames: {[key in SsciRoutes | AutoCheckinRoutes]: string} = {
  [AutoCheckinRoutes.autoCheckinBoardingPass]: 'Auto-Checkin Boarding Pass page',
  [AutoCheckinRoutes.autoCheckinDangerousGoods]: 'Auto-Checkin Dangerous goods page',
  [AutoCheckinRoutes.autoCheckinError]: 'Auto-Checkin Error page',
  [SsciRoutes.baggage]: 'Baggage page',
  [SsciRoutes.boardingPass]: 'Boarding pass page',
  [SsciRoutes.boardingPassDelivery]: 'Boarding pass delivery page',
  [SsciRoutes.cancel]: 'Cancel your check-in',
  [SsciRoutes.catalog]: 'Catalog page',
  [SsciRoutes.challenge]: 'Challenge page',
  [SsciRoutes.checkinError]: 'Error page',
  [SsciRoutes.confirmCancelCheckin]: 'Confirm cancel checkin page',
  [SsciRoutes.customerContact]: 'Contact information page',
  [SsciRoutes.dangerousGoods]: 'Dangerous goods page',
  [SsciRoutes.exitRowEligibility]: 'Exit row eligibility page',
  [SsciRoutes.homePrintedBagTags]: 'Home printed bag tags',
  [SsciRoutes.identification]: 'Identification page',
  [SsciRoutes.journeySelection]: 'Journey Selection page',
  [SsciRoutes.mandate]: 'Mandate page',
  [SsciRoutes.overview]: 'Overview page',
  [SsciRoutes.reviewCheckin]: 'Review checkin page',
  [SsciRoutes.passengerSelection]: 'Passenger selection page',
  [SsciRoutes.passengerSelectionContact]: 'Passenger selection contact page',
  [SsciRoutes.payment]: 'Payment page',
  [SsciRoutes.regulatoryDetails]: 'Regulatory information page',
  [SsciRoutes.seatmap]: 'Seat selection page',
  [SsciRoutes.securityQuestions]: 'Security questions page',
  [SsciRoutes.service]: 'Service page',
  [SsciRoutes.travelerIdentityWidgetPassport]: 'Regulatory information page - Traveler identity - Passport',
  [SsciRoutes.travelerIdentityWidgetEntryVerifier]: 'Regulatory information page - Traveler identity - Entry Verifier',
  [SsciRoutes.verification]: 'Enter verification code page',
  [SsciRoutes.voluntaryDeniedBoarding]: 'Voluntary denied boarding page',
  [SsciRoutes.alternativeFlights]: 'Alternative flights page'
};

export const enum PagesTitle {
  baggage = 'refx-title.baggage',
  boardingPass = 'refx-title.boarding-pass',
  boardingPassDelivery = 'refx-title.boarding-pass-delivery',
  catalog = 'refx-title.catalog',
  cancel = 'refx-title.cancel',
  challenge = 'refx-title.challenge',
  checkinError = 'refx-title.checkin-error',
  customerContact = 'refx-title.customer-contact',
  confirmCancelCheckin = 'refx-title.confirmation',
  dangerousGoods = 'refx-title.dangerous-goods',
  identification = 'refx-title.identification',
  journeySelection = 'refx-title.journey-selection',
  overview = 'refx-title.overview',
  passengerSelection = 'refx-title.passenger-selection',
  passengerSelectionContact = 'refx-title.passenger-selection-contact',
  payment = 'refx-title.payment',
  priorityBoarding = 'refx-title.priority-boarding',
  regulatoryDetails = 'refx-title.regulatory-details',
  seatmap = 'refx-title.seatmap',
  securityQuestions = 'refx-title.security-questions',
  services = 'refx-title.services',
  homePrintedBagTags = 'refx-title.home-printed-bag-tags',
  verification = 'refx-title.verification',
  autoCheckinError = 'refx-title.auto-checkin-error',
  autoCheckinDangerousGoods = 'refx-title.auto-checkin-dangerous-goods',
  autoCheckinBoardingPass = 'refx-title.auto-checkin-boarding-pass',
  travelerIdentityWidgetPassport = 'refx-title.traveler-identity-widget-passport',
  travelerIdentityWidgetEntryVerifier = 'refx-title.traveler-identity-widget-entry-verifier',
  reviewCheckin = 'refx-title.review-checkin',
  mandate = 'refx-title.mandate',
  exitRowEligibility = 'refx-title.exit-row-eligibility',
  voluntaryDeniedBoarding = 'refx-title.voluntary-denied-boarding',
  alternativeFlights = 'refx-title.alternative-flights'
}

export const pageDetails: {[page in pageIds]: {titleKey: PagesTitle;
  description: string;
  name: SsciRoutes | AutoCheckinRoutes;}} = {
  [pageIds.identification]: {
    titleKey: PagesTitle.identification,
    description: pageNames[SsciRoutes.identification],
    name: SsciRoutes.identification
  },
  [pageIds.baggage]: {
    titleKey: PagesTitle.baggage,
    description: pageNames[SsciRoutes.baggage],
    name: SsciRoutes.baggage
  },
  [pageIds.boardingPass]: {
    titleKey: PagesTitle.boardingPass,
    description: pageNames[SsciRoutes.boardingPass],
    name: SsciRoutes.boardingPass
  },
  [pageIds.boardingPassDelivery]: {
    titleKey: PagesTitle.boardingPassDelivery,
    description: pageNames[SsciRoutes.boardingPassDelivery],
    name: SsciRoutes.boardingPassDelivery
  },
  [pageIds.challenge]: {
    titleKey: PagesTitle.challenge,
    description: pageNames[SsciRoutes.challenge],
    name: SsciRoutes.challenge
  },
  [pageIds.checkinError]: {
    titleKey: PagesTitle.checkinError,
    description: pageNames[SsciRoutes.checkinError],
    name: SsciRoutes.checkinError
  },
  [pageIds.autoCheckinError]: {
    titleKey: PagesTitle.autoCheckinError,
    description: pageNames[AutoCheckinRoutes.autoCheckinError],
    name: AutoCheckinRoutes.autoCheckinError
  },
  [pageIds.autoCheckinDangerousGoods]: {
    titleKey: PagesTitle.autoCheckinDangerousGoods,
    description: pageNames[AutoCheckinRoutes.autoCheckinDangerousGoods],
    name: AutoCheckinRoutes.autoCheckinDangerousGoods
  },
  [pageIds.autoCheckinBoardingPass]: {
    titleKey: PagesTitle.autoCheckinBoardingPass,
    description: pageNames[AutoCheckinRoutes.autoCheckinBoardingPass],
    name: AutoCheckinRoutes.autoCheckinBoardingPass
  },
  [pageIds.customerContact]: {
    titleKey: PagesTitle.customerContact,
    description: pageNames[SsciRoutes.customerContact],
    name: SsciRoutes.customerContact
  },
  [pageIds.journeySelection]: {
    titleKey: PagesTitle.journeySelection,
    description: pageNames[SsciRoutes.journeySelection],
    name: SsciRoutes.journeySelection
  },
  [pageIds.passengerSelection]: {
    titleKey: PagesTitle.passengerSelection,
    description: pageNames[SsciRoutes.passengerSelection],
    name: SsciRoutes.passengerSelection
  },
  [pageIds.passengerSelectionContact]: {
    titleKey: PagesTitle.passengerSelectionContact,
    description: pageNames[SsciRoutes.passengerSelectionContact],
    name: SsciRoutes.passengerSelectionContact
  },
  [pageIds.overview]: {
    titleKey: PagesTitle.overview,
    description: pageNames[SsciRoutes.overview],
    name: SsciRoutes.overview
  },
  [pageIds.homePrintedBagTags]: {
    titleKey: PagesTitle.homePrintedBagTags,
    description: pageNames[SsciRoutes.homePrintedBagTags],
    name: SsciRoutes.homePrintedBagTags
  },
  [pageIds.payment]: {
    titleKey: PagesTitle.payment,
    description: pageNames[SsciRoutes.payment],
    name: SsciRoutes.payment
  },
  [pageIds.regulatoryDetails]: {
    titleKey: PagesTitle.regulatoryDetails,
    description: pageNames[SsciRoutes.regulatoryDetails],
    name: SsciRoutes.regulatoryDetails
  },
  [pageIds.seatmap]: {
    titleKey: PagesTitle.seatmap,
    description: pageNames[SsciRoutes.seatmap],
    name: SsciRoutes.seatmap
  },
  [pageIds.securityQuestions]: {
    titleKey: PagesTitle.securityQuestions,
    description: pageNames[SsciRoutes.securityQuestions],
    name: SsciRoutes.securityQuestions
  },
  [pageIds.catalog]: {
    titleKey: PagesTitle.catalog,
    description: pageNames[SsciRoutes.catalog],
    name: SsciRoutes.catalog
  },
  [pageIds.service]: {
    titleKey: PagesTitle.services,
    description: pageNames[SsciRoutes.service],
    name: SsciRoutes.service
  },
  [pageIds.cancel]: {
    titleKey: PagesTitle.cancel,
    description: pageNames[SsciRoutes.cancel],
    name: SsciRoutes.cancel
  },
  [pageIds.verification]: {
    titleKey: PagesTitle.verification,
    description: pageNames[SsciRoutes.verification],
    name: SsciRoutes.verification
  },
  [pageIds.confirmation]: {
    titleKey: PagesTitle.confirmCancelCheckin,
    description: pageNames[SsciRoutes.confirmCancelCheckin],
    name: SsciRoutes.confirmCancelCheckin
  },
  [pageIds.dangerousGoods]: {
    titleKey: PagesTitle.dangerousGoods,
    description: pageNames[SsciRoutes.dangerousGoods],
    name: SsciRoutes.dangerousGoods
  },
  [pageIds.travelerIdentityWidgetPassport]: {
    titleKey: PagesTitle.travelerIdentityWidgetPassport,
    description: pageNames[SsciRoutes.travelerIdentityWidgetPassport],
    name: SsciRoutes.travelerIdentityWidgetPassport
  },
  [pageIds.travelerIdentityWidgetEntryVerifier]: {
    titleKey: PagesTitle.travelerIdentityWidgetEntryVerifier,
    description: pageNames[SsciRoutes.travelerIdentityWidgetEntryVerifier],
    name: SsciRoutes.travelerIdentityWidgetEntryVerifier
  },
  [pageIds.reviewCheckin]: {
    titleKey: PagesTitle.reviewCheckin,
    description: pageNames[SsciRoutes.reviewCheckin],
    name: SsciRoutes.reviewCheckin
  },
  [pageIds.mandate]: {
    titleKey: PagesTitle.mandate,
    description: pageNames[SsciRoutes.mandate],
    name: SsciRoutes.mandate
  },
  [pageIds.exitRowEligibility]: {
    titleKey: PagesTitle.exitRowEligibility,
    description: pageNames[SsciRoutes.exitRowEligibility],
    name: SsciRoutes.exitRowEligibility
  },
  [pageIds.voluntaryDeniedBoarding]: {
    titleKey: PagesTitle.voluntaryDeniedBoarding,
    description: pageNames[SsciRoutes.voluntaryDeniedBoarding],
    name: SsciRoutes.voluntaryDeniedBoarding
  },
  [pageIds.alternativeFlights]: {
    titleKey: PagesTitle.alternativeFlights,
    description: pageNames[SsciRoutes.alternativeFlights],
    name: SsciRoutes.alternativeFlights
  }
};

/** Enum for all the routes in the application */
export type AppRoutes = SsciRoutes | AutoCheckinRoutes | AutoCheckinLandingRoute | DirectBoardingPassRoute;

/**
 * The routes for which the skeleton loader should be displayed
 */
export const skeletalRoutes: AppRoutes[] = [
  SsciRoutes.identification,
  SsciRoutes.journeySelection,
  SsciRoutes.overview
];
